module.exports = __webpack_public_path__ + "f2e61850ef4b47cebd3c17d995200a06.MP3";